export default () => {
  const $window = $(window);
  const $page = $('html, body');
  const $body = $('body');
  const $header = $('#js-header');
  const $logo = $('.c-logo__link');
  const $activeNav = $('.c-nav .active a');
  const $pageWrapper = $('#js-wrapper');
  const $hamburger = $('#js-hamburger');

  function closeMobileMenu() {
    $body.removeClass('has-mobile-menu-open');
    $header.removeClass('is-open');
  }

  function scrollUp() {
    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', () => {
      $page.stop();
    });

    $page.animate({ scrollTop: 0 }, 'slow', () => {
      $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
    });
  }

  // if you click on the logo and the mobile menu is open, let's close the menu
  $logo.on('click', () => {
    if($body.hasClass('has-mobile-menu-open')) {
      closeMobileMenu();
    }

    if($body.hasClass('page-template-template-homepage')) {
      scrollUp();
      return false;
    }
  });

  // If you click on the nav link and you're already on that page, scroll up
  $activeNav.on('click', () => {
    scrollUp();

    if($body.hasClass('has-mobile-menu-open')) {
      closeMobileMenu();
    }

    return false;
  });

  $pageWrapper.on('click', (e) => {
    if($body.hasClass('has-mobile-menu-open')) {
      closeMobileMenu();
    }
  });

  $hamburger.on('click', (e) => {
    e.preventDefault();

    $header.toggleClass('is-open');
    $body.toggleClass('has-mobile-menu-open');
  });

  $('#js-wrapper, #js-header').on('scroll touchmove mousewheel', function(e) {
    if($body.hasClass('has-mobile-menu-open')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });

  $window.on('resize', (e) => {
    if($window.width() > mobileBreakpoint) {
      closeMobileMenu();
    }
  });
}
